'use client';
import React from 'react';

export default function IntroSection() {
  return (
    <section
      className="w-full"
      style={{ backgroundColor: '#E8D8D5', paddingTop: 'clamp(48px, 6vw, 80px)', paddingBottom: 'clamp(48px, 6vw, 80px)' }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 clamp(24px, 4vw, 64px)' }}>
        <p
          style={{
            fontFamily: 'orpheus-pro, Georgia, serif',
            fontSize: 'clamp(28px, 4vw, 60px)',
            fontWeight: '400',
            color: '#1A2332',
            lineHeight: '1.25',
            fontStyle: 'normal',
            textAlign: 'center',
          }}
        >
          Exceptional psychological care,<br />
          thoughtfully tailored to you.
        </p>
      </div>
    </section>
  );
}
